import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ConditionTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.contrastText
}));

export const ConditionTypo = styled(Typography)(() => ({
  color: '#000000'
}));